module.exports = __webpack_public_path__ + "static/media/gp.c2c4da0e.svg";